import React from 'react';
import { LiveKitVideoDisplayController } from './controllers/LiveKitVideoDisplayController';
import { LiveKitVideoDisplayProps } from './types/LiveKitVideoDisplay.types';

/**
 * LiveKitVideoDisplayFactory
 * Entry point for rendering LiveKit video displays in a modular, scalable way.
 * Use inside LiveKitProximityProvider (see LiveKitVideoDisplay index).
 */
export const LiveKitVideoDisplayFactory: React.FC<LiveKitVideoDisplayProps> = (props) => {
  return <LiveKitVideoDisplayController {...props} />;
};

export default LiveKitVideoDisplayFactory; 